export function addCellStyle(row, key, css_class) {
	if (!row || !key || !css_class) return;

	let classes = null;
	if (Array.isArray(css_class)) {
		classes = css_class;
	} else {
		if (typeof css_class === 'string') classes = [css_class];
		else return;
	}

	if (!row.cell_style) {
		row.cell_style = {};
		row.cell_style[key] = classes;
	} else if (!row.cell_style[key]) {
		row.cell_style[key] = classes;
	} else {
		if (Array.isArray(row.cell_style[key])) {
			row.cell_style[key].push(...classes);
		} else if (typeof row.cell_style[key] === 'string') {
			classes.push(row.cell_style[key]);
			row.cell_style[key] = classes;
		}
	}
}
